
import Pricing from "./pricing";

export { Page }

function Page() {
  return <Pricing />;
}
